import React, { useState } from 'react'
import "./AddToCart.css";

function AddToCart({id, value}) {

    const [count, setCount] = useState(0);

    const setProductCount = (e) => {
        const v = e.target.value;
        if(v >= 0 && v <= 1000){
            setCount(v);
        }
    }

    return (
        <div className="product-cart">
            <input type="number" value={count || ""} onChange={setProductCount} step={1} placeholder="Enter qty e.g. 2"/>
            <p>Total price: ₹ {count * parseInt(value.value.split(",").join(""))}</p>
            <div className="text-center">
                <button className="cart-btn">Add To Cart</button>
            </div>
        </div>
    )
}

export default AddToCart
